








































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Card from '@/components/Card.vue';
import {
  EditedImage,
  ImageStatus,
  JbicImage,
  JbicImageVersion
} from '@/store/modules/admin/types/admin.types';
import TableActionDropdown from '@/components/TableActionDropdown.vue';
import { checkJbicPermission } from '@/utils/rbac.util';
import { JbicPermissions } from '@/store/modules/roles-and-permissions/types/roles-and-permissions.types';

@Component({
  components: {
    Card,
    TableActionDropdown
  }
})
export default class ImageCard extends Vue {
  @Prop() public image!: JbicImage;
  @Prop() public editedImage!: JbicImageVersion;
  @Prop() public isSelected!: boolean;

  public isImageSelected: boolean = false;

  get imageUrl() {
    return this.image.imageUrl;
  }

  get imageCaption() {
    return this.image.caption;
  }

  get isJbicImageUpdateRole(): boolean {
    return checkJbicPermission(
      JbicPermissions.IMAGE_UPDATE,
      this.image.groupId
    );
  }

  get isJbicImageDeleteRole(): boolean {
    return checkJbicPermission(
      JbicPermissions.IMAGE_DELETE,
      this.image.groupId
    );
  }

  get isImageEditable() {
    return (
      this.isJbicImageUpdateRole && this.image.status !== ImageStatus.PUBLISHED
    );
  }

  editImage() {
    const editedImage: EditedImage = {
      images: this.image,
      lastReviewImages: this.editedImage ?? null
    };
    this.$parent?.$parent?.$parent?.$emit('toggleEditImage', editedImage);
  }

  deleteImage(imageId: number) {
    this.$parent?.$parent?.$parent?.$emit('deleteImage', imageId);
  }

  goToDetails() {
    const editedImage: EditedImage = {
      images: this.image,
      lastReviewImages: this.editedImage ?? null
    };
    this.$parent?.$parent?.$parent?.$emit('toggleViewImage', editedImage);
  }

  selectImage() {
    this.$emit('selectImage', {
      imageId: this.image.id,
      isSelected: this.isImageSelected
    });
  }

  @Watch('isSelected')
  onIsSelected() {
    this.isImageSelected = this.isSelected;
  }
}
